import React, {Fragment} from 'react';
import GreenLeafApi from '../utils/GreenLeafApi';
import {Clearfix, DropdownButton, FormControl, FormGroup, HelpBlock, MenuItem, Panel} from 'react-bootstrap';
import * as moment from 'moment';
import EditableEngagement from './EditableEngagement';
import ErrorComponent from '../ErrorComponent';
import AddItemModal from './AddItemModal';
import EditableField from './EditableField';
import validator from 'validator';
import ContactSelector from './ContactSelector';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, {formatDate, parseDate} from 'react-day-picker/moment';
import _ from 'lodash';
import NotesModal from './NotesModal';
import AttachmentModal from './AttachmentModal';
import {ToastContainer} from 'react-toastify';

class EngagementPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      engagement: {},
      files: [],
      agreements: [],
      recommendations: [],
      isLoading: true,
      disabled: true,
      errors: [],
      showModalType: '',
      coach: '',
      editingCoach: false,
      coachValidation: '',
      showNotesModal: false,
      showAttachmentModal: false,
    };
  }

  async componentDidMount() {
    try {
      let engagement = await GreenLeafApi.Engagement.get({engagementId: this.props.match.params.engagementId});

      engagement = engagement.data.engagements[0];

      let files = await GreenLeafApi.Engagement.Attachment.get(engagement.id);

      this.setState({engagement, coach: engagement.coach || '', files: files.data});
      if(engagement.contracts) {
        this.organizeContracts(engagement);
      }
    } catch (e) {
      this.setState({errors: e.errors});
    }
    this.setState({isLoading: false});
  }

  updateContract = (contract) => {
    this.setState(prevState => ({
      engagement: {
        ...prevState.engagement,
        contracts: prevState.engagement.contracts.map(c => {
          if(c.id === contract.id){
            return contract;
          }
          return c;
        })
      }
    }));
  };

  organizeContracts = (engagement) => {
    let recommendations = [];
    let agreements = [];
    engagement.contracts.forEach(c => {
      if(c.recommendation){
        recommendations.push(c.id);
      }
      if(c.status === 'agreed'){
        agreements.push(c.id);
      }
    });
    this.setState({agreements, recommendations});
  };

  getSponsorName = () => {
    return this.state.engagement.sponsor && this.state.engagement.sponsor.first_name ?
      this.state.engagement.sponsor.first_name + ' ' + this.state.engagement.sponsor.last_name : 'N/A';
  };

  agreeWithRecommendation = async (r) => {
    let agreement = r;
    agreement.status = 'agreed';

    try {
      let response = await GreenLeafApi.Engagement.Contract.update(this.state.engagement.id, agreement);

      this.updateContract(response.data.contract);
      this.setState(prevState => ({
        agreements: [...prevState.agreements, response.data.contract.id]
      }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  deferRecommendation = async (r) => {
    let recommendation = r;
    recommendation.status = 'deferred';

    try {
      let response = await GreenLeafApi.Engagement.Contract.update(this.state.engagement.id, recommendation);

      this.updateContract(response.data.contract);
      this.setState(prevState => ({
        agreements: prevState.agreements.filter(id => id !== response.data.contract.id),
      }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  addRecommendation = async (text) => {
    let c = {
      text,
      engagement_id: this.props.match.params.engagementId
    };

    try {
      let response = await GreenLeafApi.Engagement.Contract.create(this.state.engagement.id, c);

      this.setState(prevState => ({
        engagement: {
          ...prevState.engagement,
          contracts: [...(prevState.engagement.contracts || []), response.data.recommendation]
        },
        recommendations: [...prevState.recommendations, response.data.recommendation.id],
        showModalType: ''
      }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  addAgreement = async (text) => {
    let a = {
      text,
      engagement_id: this.state.engagement.id,
    };

    try {
      let response = await GreenLeafApi.Engagement.Agreement.create(this.state.engagement.id, a);

      this.setState(prevState => ({
        engagement: { ...prevState.engagement, contracts: [...prevState.engagement.contracts, response.data.agreement]},
        agreements: [...prevState.agreements, response.data.agreement.id],
        showModalType: ''
      }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  addGoal = async (g) => {

    try {
      let response = await GreenLeafApi.Engagement.Goal.create(this.state.engagement.id, g);

      this.setState(prevState => ({
        engagement: {
          ...prevState.engagement,
          goals: [...prevState.engagement.goals, response.data.goal]
        },
        showModalType: ''
      }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  removeContract = async (c) => {

    try {
      await GreenLeafApi.Engagement.Contract.delete(this.state.engagement.id, c.id);

      this.setState(prevState => ({
        engagement: {
          ...prevState.engagement,
          contracts: prevState.engagement.contracts.filter(con => con.id !== c.id)
        },
        agreements: prevState.agreements.filter(id => id !== c.id),
        recommendations: prevState.recommendations.filter(id => id !== c.id),
      }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  removeGoal = async (g) => {

    try {
      await GreenLeafApi.Engagement.Goal.delete(this.state.engagement.id, g.id);

      this.setState(prevState => ({
        engagement: {
          ...prevState.engagement,
          goals: prevState.engagement.goals.filter(goal => goal.id !== g.id)
        }
      }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  setModalType = (type) => {
    this.setState({ showModalType: type });
  };

  onCoachChange = (event) => {
    let target = event.target;
    this.setState({ coach: target.value });
  };

  toggleEditCoach = async (editing) => {
    if (editing) {
      this.setState({ editingCoach: true });
    } else {
      if (validator.isEmpty(this.state.coach) || this.state.coach === this.state.engagement.coach) {
        this.setState({ editingCoach: false });
      } else if (!validator.isEmail(this.state.coach)) {
        this.setState({ coachValidation: 'Must be a valid email.' });
      } else {
        const currentEngagement = this.state.engagement;
        const engagement = {
          id: currentEngagement.id,
          company_id: currentEngagement.company_id,
          coach: this.state.coach,
          sponsor: currentEngagement.sponsor.id,
          start_date: currentEngagement.start_date,
          end_date: currentEngagement.end_date,
          status: currentEngagement.status
        };

        try {
          await GreenLeafApi.Engagement.update(engagement);

          this.setState(prevState => ({
            engagement: {
              ...prevState.engagement,
              coach: prevState.coach
            },
            editingCoach: false
          }));
        }catch (e) {
          this.setState({errors: e.errors});
        }
      }
    }
  };

  onContactSelect = async (contact) => {
    const currentEngagement = this.state.engagement;
    const engagement = {
      id: currentEngagement.id,
      company_id: currentEngagement.company_id,
      coach: currentEngagement.coach,
      sponsor: contact ? contact.id : null,
      start_date: currentEngagement.start_date,
      end_date: currentEngagement.end_date,
      status: currentEngagement.status
    };

    try {
      await GreenLeafApi.Engagement.update(engagement);

      this.setState(prevState => ({
        engagement: {
          ...prevState.engagement,
          sponsor: contact
        }
      }));
    } catch (e) {
      this.setState({ errors: e.errors });
    }
  };

  changeDate = async (type, date) => {
    const currentEngagement = this.state.engagement;
    const engagement = {
      id: currentEngagement.id,
      company_id: currentEngagement.company_id,
      coach: currentEngagement.coach,
      sponsor: currentEngagement.sponsor.id,
      start_date: currentEngagement.start_date,
      end_date: currentEngagement.end_date,
      status: currentEngagement.status
    };

    if (type === 'START') {
      engagement.start_date = date;
    } else if(type === 'END') {
      engagement.end_date = date;
    }

    try {
      await GreenLeafApi.Engagement.update(engagement);


      this.setState(prevState => ({
        engagement: {
          ...prevState.engagement,
          ...engagement,
          sponsor: prevState.engagement.sponsor
        }
      }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  changeStatus = async (status) => {
    const currentEngagement = this.state.engagement;
    const engagement = {
      id: currentEngagement.id,
      company_id: currentEngagement.company_id,
      coach: currentEngagement.coach,
      sponsor: (currentEngagement.sponsor || {}).id || null,
      start_date: currentEngagement.start_date,
      end_date: currentEngagement.end_date,
      status
    };

    try {
      await GreenLeafApi.Engagement.update(engagement);

      this.setState(prevState => ({
        engagement: {
          ...prevState.engagement,
          status
        }
      }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  editGoal = async (goal, index) => {
    if (!_.isEqual(this.state.engagement.goals[index], goal)) {
      try {
        await GreenLeafApi.Engagement.Goal.update(this.state.engagement.id, goal);

        this.setState(prevState => ({
          engagement: {
            ...prevState.engagement,
            goals: prevState.engagement.goals.map(g => {
              if (g.id === goal.id) {
                return goal;
              }
              return g;
            })
          }
        }));
      } catch (e) {
        this.setState({errors: e.errors});
      }
    }
  };

  onSubmitContract = async (con) => {
    try {
      await GreenLeafApi.Engagement.Contract.update(this.state.engagement.id, con);
      this.updateContract(con);
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  onEditNote = async (note) => {
    try {
      await GreenLeafApi.Engagement.Note.update(this.state.engagement.id, note);

      this.setState(prevState => ({
        engagement: {
          ...prevState.engagement,
          notes: prevState.engagement.notes.map(n => {
            if (n.id === note.id) {
              return note;
            }
            return n;
          })
        }
      }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  onCreateNote = async (note) => {
    try {
      let response = await GreenLeafApi.Engagement.Note.create(this.state.engagement.id, note);

      this.setState(prevState => ({
        engagement: {
          ...prevState.engagement,
          notes: [...(prevState.engagement.notes || []), response.data.note]
        }
      }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  onDeleteNote = async (n) => {

    try {
      await GreenLeafApi.Engagement.Note.delete(this.state.engagement.id, n.id);

      this.setState(prevState => ({
        engagement: {
          ...prevState.engagement,
          notes: prevState.engagement.notes.filter(note => note.id !== n.id)
        }
      }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  uploadAttachments = async (files) => {
    const data = new FormData();

    files.forEach(file => {
      data.append('engagementFiles', file);
    });

    try {
      let response = await GreenLeafApi.Engagement.Attachment.upload(this.state.engagement.id, data);
      this.setState(prevState => ({ files: [...prevState.files, ...response.data] }));
    } catch (e) {
      this.setState({errors: e.errors});
    }
  };

  deleteAttachment = async (attachment) => {
    try {
      await GreenLeafApi.Engagement.Attachment.delete(this.state.engagement.id, attachment.file_location);

      this.setState(prevState => ({
        files: prevState.files.filter(f => f.id !== attachment.id)
      }));
    } catch (e) {
      this.setState({ errors: e.errors });
    }
  };

  render() {
    if (this.state.isLoading) {
      return <p>Loading...</p>;
    }

    const disableEdit = this.state.engagement.status === 'DENIED';

    return (
      <div>

        <ErrorComponent error={this.state.errors}/>

        <h2 data-cy="engagement-header" className='ta-center'>
          Engagement
        </h2>
        <br/>

        <Panel>
          <Panel.Heading>
            <Panel.Title componentClass="h3" className='relative'>
              <div className={'float-vertical-align pull-left'}>
                Details
              </div>
              <div className={'pull-right'}>
                <DropdownButton
                  data-cy="dropdown-button"
                  pullRight
                  title=''
                  id='engagement-dropdown'
                >
                  {
                    this.state.engagement.status === 'PROPOSED' &&
                    <Fragment>
                      <MenuItem data-cy='approve-button' onClick={() => this.changeStatus('CONFIRMED')}>Approve</MenuItem>
                      <MenuItem data-cy='deny-button' onClick={() => this.changeStatus('DENIED')}>Deny</MenuItem>
                    </Fragment>
                  }
                  <MenuItem data-cy='view-notes-button' onClick={() => this.setState({showNotesModal: true})}>View Notes</MenuItem>
                  <MenuItem data-cy='view-attachments-button' onClick={() => this.setState({ showAttachmentModal: true })}>View Attachments</MenuItem>

                </DropdownButton>
              </div>
              <Clearfix/>
            </Panel.Title>

          </Panel.Heading>
          <Panel.Body>
            <h4 data-cy='status' className='flex-row'>
              Status:&nbsp;&nbsp;{this.state.engagement.status}
            </h4>
            <br/>
            <h4 data-cy='coach' className='flex-row' style={{ minHeight: '34px' }}>
              Coach:&nbsp;&nbsp;
              {
                !disableEdit ?
                  <EditableField
                    value={<h4 className='m0'>{this.state.engagement.coach || 'N/A'}</h4>}
                    editing={this.state.editingCoach}
                    onToggle={this.toggleEditCoach}
                  >
                    <FormGroup controlId='formHorizontalEmail' className='mb0' validationState={this.state.coachValidation ? 'error' : null}>
                      <FormControl placeholder='Email' value={this.state.coach || ''} onChange={this.onCoachChange}/>
                      { this.state.coachValidation && <HelpBlock style={{ fontSize: '10px' }}>{this.state.coachValidation}</HelpBlock> }
                    </FormGroup>
                  </EditableField>
                  :
                  this.state.engagement.coach || 'N/A'
              }
            </h4>
            <br/>
            <div data-cy='sponsor' className='flex-row'>
              <h4 className='flex-row'>
                Sponsor:&nbsp;&nbsp;
              </h4>
              {
                !disableEdit ?
                  <EditableField value={<h4 className='m0'>{this.getSponsorName() || 'N/A'}</h4>}>
                    <ContactSelector contact={this.state.engagement.sponsor} onSelect={this.onContactSelect}/>
                  </EditableField>
                  :
                  <h4>{this.getSponsorName()}</h4>
              }
            </div>
            <br/>
            <div data-cy='start-date' className='flex-row'>
              <h4>
                Start Date:&nbsp;&nbsp;
              </h4>
              {
                !disableEdit ?
                  <DayPickerInput
                    formatDate={formatDate}
                    parseDate={parseDate}
                    placeholder='MM/DD/YYYY'
                    hideOnDayClick
                    value={this.state.engagement.start_date ? moment(this.state.engagement.start_date).format('L') : ''}
                    dayPickerProps={{
                      locale: 'en-us',
                      localeUtils: MomentLocaleUtils,
                      disabledDays: { before: new Date() }
                    }}
                    onDayChange={(day) => this.changeDate('START', day)}
                  />
                  :
                  <h4>{ this.state.engagement.start_date ? moment(this.state.engagement.start_date).format('L') : 'N/A'}</h4>
              }
            </div>
            <br/>
            <div data-cy="end-date" className='flex-row'>
              <h4>
                End Date:&nbsp;&nbsp;&nbsp;
              </h4>
              {
                !disableEdit ?
                  <DayPickerInput
                    formatDate={formatDate}
                    parseDate={parseDate}
                    placeholder='MM/DD/YYYY'
                    hideOnDayClick
                    value={this.state.engagement.end_date ? moment(this.state.engagement.end_date).format('L') : ''}
                    dayPickerProps={{
                      locale: 'en-us',
                      localeUtils: MomentLocaleUtils,
                      disabledDays: { before: new Date() }
                    }}
                    onDayChange={(day) => this.changeDate('END', day)}
                  />
                  :
                  <h4>{ this.state.engagement.end_date ? moment(this.state.engagement.end_date).format('L') : 'N/A'}</h4>
              }
            </div>
          </Panel.Body>
        </Panel>

        <EditableEngagement
          engagement={this.state.engagement}
          agreements={this.state.agreements}
          recommendations={this.state.recommendations}
          agree={this.agreeWithRecommendation}
          defer={this.deferRecommendation}
          removeContract={this.removeContract}
          removeGoal={this.removeGoal}
          addAgreement={() => this.setModalType('Agreement')}
          addRecommendation={() => this.setModalType('Recommendation')}
          addGoal={() => this.setModalType('Goal')}
          disableEdit={disableEdit}
          onSubmitContract={this.onSubmitContract}
          editGoal={this.editGoal}
        />

        <AddItemModal
          show={!!this.state.showModalType}
          type={this.state.showModalType}
          addAgreement={this.addAgreement}
          addRecommendation={this.addRecommendation}
          addGoal={this.addGoal}
          handleHide={() => this.setModalType('')}
        />

        <NotesModal
          show={this.state.showNotesModal}
          onEditNote={this.onEditNote}
          onCreateNote={this.onCreateNote}
          onDeleteNote={this.onDeleteNote}
          handleClose={() => this.setState({showNotesModal: false})}
          notes={this.state.engagement.notes}
        />

        <AttachmentModal
          show={this.state.showAttachmentModal}
          onHide={() => this.setState({ showAttachmentModal: false })}
          uploadFiles={this.uploadAttachments}
          deleteFile={this.deleteAttachment}
          files={this.state.files}
        />

        <ToastContainer
          position="top-center"
          autoClose={1500}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggablePercent={80}
          pauseOnHover
        />
      </div>
    );
  }

}

export default EngagementPage;


// WEBPACK FOOTER //
// ./src/components/engagement/EngagementPage.js